module.exports = __webpack_public_path__ + "static/media/1.0861b6d1.jpg";